import { PERSONAL_NUMBER_PATTERN } from 'utils/patterns/personalNumber';

export const isValidPersonalNumber = (personalNumber) => {
  const personalNumberRE = new RegExp(PERSONAL_NUMBER_PATTERN);
  return personalNumberRE.test(personalNumber);
};
